import axiosConfig from "./axiosConfig";

class ParcoursService {
  async getAll() {
    try {
      const response = await axiosConfig.get("/parcours");
      return response.data || [];
    } catch (error) {
      console.error("Error fetching parcours:", error);
      return [];
    }
  }

  async create(formData) {
    try {
      const response = await axiosConfig.post("/parcours", formData);
      return response.data;
    } catch (error) {
      console.error(
        "❌ Erreur lors de la création:",
        error.response?.data || error.message
      );
      return Promise.reject(error.response?.data || { message: error.message });
    }
  }

  async update(id, formData) {
    try {
      const response = await axiosConfig.put(`/parcours/${id}`, formData);
      return response.data;
    } catch (error) {
      console.error(
        "❌ Erreur lors de la mise à jour:",
        error.response?.data || error.message
      );
      return Promise.reject(error.response?.data || { message: error.message });
    }
  }

  async delete(id) {
    try {
      const response = await axiosConfig.delete(`/parcours/${id}`);
      return response.data;
    } catch (error) {
      console.error(
        "❌ Erreur lors de la suppression:",
        error.response?.data || error.message
      );
      return Promise.reject(error.response?.data || { message: error.message });
    }
  }
}

const ParcoursServiceInstance = new ParcoursService();
export default ParcoursServiceInstance;
